if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      attachStockMessage(formData) {
        const sectionId = this.dataset.sectionId;
        const node = document.querySelector(`#StockMessaging-${sectionId}`);
        if (!node) return;

        // Quantity from the closest product-info
        const productInfo = this.closest('product-info');
        const qtyInput = productInfo?.querySelector('.quantity__input');
        const qty = parseInt(qtyInput?.value || '1', 10);

        // Read data attributes exposed by the merged Liquid block
        const invQty = parseInt(node.dataset.inventoryQty || '0', 10);
        const policy = (node.dataset.inventoryPolicy || '').toLowerCase();
        const weeks = node.dataset.weeks;
        const tplRaw = node.dataset.template || 'Made to order in [[value]] weeks';
        const tpl = tplRaw.replace('[[ value ]]', '[[value]]'); // normalize token

        const preorderActive = node.dataset.preorderActive === 'true';
        const preorderMsg = node.dataset.preorderMessage;

        // Compute states (match Liquid priority)
        const isOOS = invQty <= 0; // we use explicit if/else in Liquid; JS can inline
        const hasStock = invQty > 0 && qty <= invQty;
        const showMto = !hasStock && policy === 'continue' && !!weeks;

        let msg = '';

        if (isOOS && policy !== 'continue') {
          // Hard OOS (deny) overrides everything
          msg = window.variantStrings?.soldOut || 'Out of stock';
        } else if (preorderActive && preorderMsg) {
          // Pre-Order overrides MTO/In stock
          msg = preorderMsg;
        } else if (showMto) {
          msg = tpl.replace('[[value]]', weeks);
        } else {
          msg = window.variantStrings?.inStock || 'In stock, delivered within 7 days';
        }

        // Persist to line item properties (visible at checkout/email)
        formData.delete('properties[Delivery]');
        formData.append('properties[Delivery]', msg);
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        const quantityComponent = this.closest('product-info')?.querySelector('quantity-input');
        quantityComponent?.normalizeValue();

        const qtyInput = quantityComponent?.querySelector('.quantity__input');
        if (qtyInput && !qtyInput.checkValidity()) {
          qtyInput.reportValidity();
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        this.attachStockMessage(formData);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          console.info(
            '[add] requesting sections:',
            this.cart.getSectionsToRender().map((s) => s.id)
          );

          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        console.info(config, 'Submitting form with data:', [...formData.entries()]);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure('add:paint-updated-sections', () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure('add:paint-updated-sections', () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent('add:user-action', evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
